/* eslint-disable max-lines */
/* eslint-disable sonarjs/cognitive-complexity */
/* eslint-disable max-statements */
// 9fbef606107a605d69c0edbcd8029e5d
import { call, put, putResolve, takeLatest, select, fork, delay } from 'redux-saga/effects';
import logger from '@tcp/core/src/utils/loggerInstance';
import { isClient, getSiteId, getAPIConfig, getBrand, isCanada } from '@tcp/core/src/utils';
import { makeSearch } from '@tcp/core/src/services/abstractors/common/searchBar';
import {
  getIsDidYouMeanEnabled,
  getIsNonInvSessionFlag,
  getIsOtherBrandExpABTestEnabled,
  getIsPaginationViewEnabled,
  getIsSLPPersistEnabled,
  getNullSearchCatId,
  getSearchReduxState,
  getIsSnjPjpBrandDisabled,
  getIsCleanUrlForSizeEnabled,
  getIsSLPNewTileImplementationEnabled,
} from '@tcp/core/src/reduxStore/selectors/session.selectors';
import { getUnbxdXappConfigs } from '@tcp/core/src/components/features/browse/ProductListing/container/ProductListing.saga';
import { loadLayoutData, loadModulesData } from '@tcp/core/src/reduxStore/actions';
import { isTier2Device, isTier3Device } from '@tcp/web/src/utils/device-tiering';
import { resetAlternateBrandInPickUp } from '@tcp/core/src/components/common/organisms/PickupStoreModal/container/PickUpStoreModal.actions';
import { SLP_PAGE_REDUCER_KEY } from '../../../../../constants/reducer.constants';
import {
  setSlpProducts,
  setSlpLoadingState,
  setSlpSearchTerm,
  setListingFirstProductsPage,
  setNOSearchResultPageFlag,
  setAcrossBrandCallFlag,
} from './SearchDetail.actions';
import { getProductsPerPageCount } from './SearchDetail.util';
import Abstractor from '../../../../../services/abstractors/productListing';
import ProductsOperator from '../../ProductListing/container/productsRequestFormatter';
import { setSearchResult } from '../../../../common/molecules/SearchBar/SearchBar.actions';
import { getLastLoadedPageNumber } from './SearchDetail.selectors';
import { getDefaultWishList } from '../../Favorites/container/Favorites.saga';
import SLP_CONSTANTS, {
  PRODUCTS_PER_LOAD,
  PRODUCTS_PER_LOAD_LOWER_END_DEVICES,
} from './SearchDetail.constants';
import { getCommonAnalyticsData } from '../../../../../analytics/Analytics.selectors';
import { setCommonAnalyticsData } from '../../../../../analytics/actions';
import { API_CONFIG } from '../../../../../services/config';

const instanceProductListing = new Abstractor();
const operatorInstance = new ProductsOperator();
let didYouMeanSuggestion;

const getUrl = (url) => {
  return url
    ? {
        pathname: url,
      }
    : window.location;
};
const isFormDataPresent = (formData, sortBySelected) => {
  return !formData && !sortBySelected;
};
const getSlpScrollFlag = (formDataPresent, isProcessedResponse, prefetchedResponse) => {
  return isClient() && formDataPresent && !isProcessedResponse && !prefetchedResponse;
};

const getIsScrollToTopFlag = (scrollToTop) => {
  return scrollToTop || false;
};

const getAlternateBrandToSearchFor = (isSnjPjpBrandDisabled) => {
  const brand = getBrand();
  if (isSnjPjpBrandDisabled) {
    if (brand === 'tcp') {
      return ['gym'];
    }
    if (brand === 'gym') {
      return ['tcp'];
    }
    return [];
  }
  if (brand === 'tcp') {
    return ['gym', 'snj', 'pjp'];
  }
  if (brand === 'gym') {
    return ['tcp', 'pjp'];
  }
  if (brand === 'snj') {
    return ['tcp', 'pjp', 'gym'];
  }
  if (brand === 'pjp') {
    return ['tcp', 'gym', 'snj'];
  }
  return [];
};

const gttFormattedData = (state, brand, alternateBrandToSearch) => {
  const departments = getNullSearchCatId(state, brand, alternateBrandToSearch);
  return departments?.split(',');
};

const getBrandConfig = (state, brand) => {
  return {
    tcp: [{ gym: '' }, { snj: '' }, { pjp: '' }],
    gym: [
      { tcp: gttFormattedData(state, brand, 'tcp') || [] },
      { pjp: gttFormattedData(state, brand, 'pjp') || [] },
      { snj: '' },
    ],
    snj: [
      { tcp: gttFormattedData(state, brand, 'tcp') || [] },
      { pjp: gttFormattedData(state, brand, 'pjp') || [] },
      { gym: '' },
    ],
    pjp: [{ tcp: '' }, { gym: gttFormattedData(state, brand, 'gym') || [] }, { snj: '' }],
  };
};

const getIsTotalProductsCountMoreThanZero = (res, isOtherBrandExpABTestFlag) => {
  return (
    (res && res.totalProductsCount > 0) ||
    res?.body?.response?.numberOfProducts === 1 ||
    !isOtherBrandExpABTestFlag
  );
};

const getLocationValue = (location) => {
  return !location.search ? `${location.pathname}?` : `${location.pathname}?${location.search}`;
};

function* getDidYouMeanSuggestion() {
  const isDidYouMeanAbEnabled = yield select(getIsDidYouMeanEnabled);
  const isDidYouMeanEnabled = isDidYouMeanAbEnabled === undefined || isDidYouMeanAbEnabled;
  if (didYouMeanSuggestion && isDidYouMeanEnabled) {
    return didYouMeanSuggestion;
  }
  return null;
}

export function* setSearchTextFirstTouch(searchQuery) {
  let commonAnalyticsData = yield select(getCommonAnalyticsData) || {};
  const searchTextFirstTouch =
    (commonAnalyticsData && commonAnalyticsData.searchTextFirstTouch) || '';
  if (!commonAnalyticsData || !searchTextFirstTouch) {
    commonAnalyticsData = { ...commonAnalyticsData, searchTextFirstTouch: searchQuery };
    yield put(setCommonAnalyticsData({ ...commonAnalyticsData }));
  }
}

export function* fetchSlpSearchResults({ payload }) {
  const suggestionsCount = {
    category: payload.isSLPPersistEnabled ? 0 : 4,
    keywords: 4,
    promotedTopQueries: payload.isSLPPersistEnabled ? 0 : 4,
  };

  const state = yield select();
  const globalSearchLabels = state?.Labels?.global?.Search;

  let slpLabels = payload?.slpLabels;
  if (slpLabels && globalSearchLabels) {
    slpLabels = { ...slpLabels, ...globalSearchLabels };
  }

  const isHideBundleProduct = false;
  const payloadData = {
    searchTerm: payload.searchText,
    suggestionsCount,
    isHideBundleProduct,
    slpLabels,
    isSLPPersistEnabled: payload.isSLPPersistEnabled,
  };

  const xappURLConfig = yield call(getUnbxdXappConfigs);
  try {
    const response = yield call(makeSearch, payloadData, xappURLConfig);
    if (
      response.autosuggestList &&
      response.autosuggestList[0] &&
      response.autosuggestList[0].suggestions.length < 1 &&
      response.autosuggestList[1] &&
      response.autosuggestList[1].suggestions.length < 1
    ) {
      yield put(setSearchResult(response));
      yield put(setNOSearchResultPageFlag(false));
    } else {
      yield put(setSearchResult(response));
      yield put(setNOSearchResultPageFlag(true));
    }
  } catch (err) {
    logger.error('Error: error in fetching Search bar results ');
  }
}

const relevantSearchUndefinedABCheck = (isSLPPersistEnabled) => {
  return isSLPPersistEnabled === undefined || isSLPPersistEnabled;
};

const getSearchTerm = (url) => {
  return url?.includes('/search/') ? url?.split('/search/')?.[1] : url;
};

const processSearchText = (search) => {
  return search?.split('?')?.[0]?.split('&')?.[0];
};

const checkResponse = (res, searchedTerm, oldResponse, oldSuggestion) => {
  const oldRes = oldResponse;

  if (res?.totalProductsCount === 0) {
    oldRes.initialSearchTerm = searchedTerm;
    oldRes.oldSearchResultSuggestions = oldSuggestion;
    return oldRes;
  }
  return res;
};

const getCommonReqObj = (
  state,
  formData,
  asPath,
  selectedPage,
  location,
  navigation,
  isFilterAbTestOn,
  isPaginationViewEnabled
) => {
  const reqObj = operatorInstance.getProductsListingFilters({
    state,
    formData,
    asPath,
    pageNumber: selectedPage,
    location,
  });
  reqObj.navigation = navigation;
  reqObj.extraParams = {
    ...reqObj.extraParams,
    ...instanceProductListing.getExtraFilterParams(isFilterAbTestOn),
  };
  if (isPaginationViewEnabled) {
    reqObj.isPaginationViewEnabled = isPaginationViewEnabled;
  }
  return reqObj;
};

const clearOldSearchSuggestion = (res, isDidYouMeanEnabled) => {
  if (!didYouMeanSuggestion && isDidYouMeanEnabled) {
    res.oldSearchResultSuggestions = '';
  }
};

// eslint-disable-next-line complexity
export function* fetchSlpProducts({ payload }) {
  try {
    const {
      prefetchedResponse,
      searchQuery,
      asPath,
      formData,
      url,
      scrollToTop,
      isKeepModalOpen,
      navigation = null,
      isFilterAbTestOn,
      sortBySelected,
      isProcessedResponse,
      selectedPage = 1,
      isFromStoreModal,
    } = payload;
    yield put(
      setAcrossBrandCallFlag({
        acrossBrandApiCalled: false,
      })
    );

    const state = yield select();
    const isPaginationViewEnabled = getIsPaginationViewEnabled(state);
    const isCleanUrlForSizeEnabled = getIsCleanUrlForSizeEnabled(state);
    const formDataPresent = isFormDataPresent(formData, sortBySelected);
    const productsCount = isPaginationViewEnabled ? getProductsPerPageCount(state) : null;
    yield put(loadLayoutData({}, 'searchListingPage'));

    const xappURLConfig = yield call(getUnbxdXappConfigs);
    const location = getUrl(url);

    yield put(resetAlternateBrandInPickUp());
    yield put(
      setSlpLoadingState({
        isLoadingMore: true,
        isScrollToTop: getIsScrollToTopFlag(scrollToTop),
        isKeepModalOpen,
        isSearchResultsAvailable: false,
        isDataLoading: true,
        selectedPage,
        alternateBrandName: '',
      })
    );

    yield call(getDefaultWishList);
    yield fork(setSearchTextFirstTouch, searchQuery);
    yield put(setSlpSearchTerm({ searchTerm: searchQuery }));
    const isNonInvABTestEnabled = yield select(getIsNonInvSessionFlag);
    let res;
    const isSLPNewTileImplementationEnabled = getIsSLPNewTileImplementationEnabled(state);
    if (prefetchedResponse) {
      const reqObj = {};
      if (isFromStoreModal) {
        reqObj.isFromStoreModal = true;
      }
      if (isCleanUrlForSizeEnabled) {
        reqObj.isCleanUrlForSizeEnabled = isCleanUrlForSizeEnabled;
      }
      if (isSLPNewTileImplementationEnabled) {
        reqObj.isSLPNewTileImplementationEnabled = isSLPNewTileImplementationEnabled;
      }
      res = yield call(
        instanceProductListing.getProducts,
        reqObj,
        state,
        prefetchedResponse,
        productsCount,
        xappURLConfig,
        isNonInvABTestEnabled,
        false
      );
    } else {
      const reqObj = getCommonReqObj(
        state,
        formData,
        asPath,
        selectedPage,
        location,
        navigation,
        isFilterAbTestOn,
        isPaginationViewEnabled
      );
      if (isFromStoreModal) {
        reqObj.isFromStoreModal = true;
      }
      if (isCleanUrlForSizeEnabled) {
        reqObj.isCleanUrlForSizeEnabled = isCleanUrlForSizeEnabled;
      }
      if (isSLPNewTileImplementationEnabled) {
        reqObj.isSLPNewTileImplementationEnabled = isSLPNewTileImplementationEnabled;
      }
      res = yield call(
        instanceProductListing.getProducts,
        reqObj,
        state,
        prefetchedResponse,
        productsCount,
        xappURLConfig,
        isNonInvABTestEnabled,
        false
      );
    }
    let alternateBrandToSearch;
    let alternateBrandWhereProductFound;
    const isOtherBrandExpABTestFlag = yield select(getIsOtherBrandExpABTestEnabled);
    const isDidYouMeanAbEnabled = yield select(getIsDidYouMeanEnabled);
    const isSnjPjpBrandDisabled = yield select(getIsSnjPjpBrandDisabled);
    const isDidYouMeanEnabled = isDidYouMeanAbEnabled === undefined || isDidYouMeanAbEnabled;
    const searchedTerm = res?.currentListingSearchForText;
    const searchReduxState = yield select(getSearchReduxState);
    const searchQueryText = searchQuery?.includes('/search/')
      ? searchQuery?.split('/search/')?.[1]
      : searchQuery;
    didYouMeanSuggestion = res?.searchResultSuggestions?.[0]?.suggestion;
    const searchResultSuggestions = res?.searchResultSuggestions;
    let payloadForSLP;

    if (!res?.redirect && res?.totalProductsCount === 0) {
      clearOldSearchSuggestion(res, isDidYouMeanEnabled);
      if (isDidYouMeanEnabled && didYouMeanSuggestion) {
        const reqObj = getCommonReqObj(
          state,
          formData,
          asPath,
          selectedPage,
          location,
          navigation,
          isFilterAbTestOn,
          isPaginationViewEnabled
        );
        reqObj.seoKeywordOrCategoryIdOrSearchTerm = didYouMeanSuggestion;
        reqObj.extraParams = {
          ...reqObj.extraParams,
          ...instanceProductListing.getExtraFilterParams(isFilterAbTestOn),
        };
        const oldResponse = res;
        if (isFromStoreModal) {
          reqObj.isFromStoreModal = true;
        }
        if (isCleanUrlForSizeEnabled) {
          reqObj.isCleanUrlForSizeEnabled = isCleanUrlForSizeEnabled;
        }
        if (isSLPNewTileImplementationEnabled) {
          reqObj.isSLPNewTileImplementationEnabled = isSLPNewTileImplementationEnabled;
        }
        res = yield call(
          instanceProductListing.getProducts,
          reqObj,
          state,
          prefetchedResponse,
          productsCount,
          xappURLConfig,
          isNonInvABTestEnabled,
          false
        );
        let isSLPPersistEnabled = yield select(getIsSLPPersistEnabled);
        isSLPPersistEnabled = relevantSearchUndefinedABCheck(isSLPPersistEnabled);
        const slpPersistSearchText = didYouMeanSuggestion;
        payloadForSLP = payload;
        payloadForSLP.searchText = processSearchText(slpPersistSearchText);
        payloadForSLP.isSLPPersistEnabled = isSLPPersistEnabled;
        yield call(fetchSlpSearchResults, { payload: payloadForSLP });
        const oldSuggestion = res?.searchResultSuggestions?.[0]?.suggestion;
        res = checkResponse(res, searchedTerm, oldResponse, oldSuggestion);
      }
    }

    if (!res) {
      yield put(
        setSlpLoadingState({
          loadedProductsPages: [],
          totalProductsCount: 0,
          isLoadingMore: false,
          isScrollToTop: false,
          isDataLoading: false,
          isSearchResultsAvailable: true,
        })
      );
    } else if (getIsTotalProductsCountMoreThanZero(res, isOtherBrandExpABTestFlag)) {
      const { layout, modules } = yield call(
        instanceProductListing.parsedModuleData,
        res.bannerInfo,
        getAPIConfig()
      );
      yield put(loadLayoutData(layout, 'searchListingPage'));
      yield put(loadModulesData(modules));

      let locationValue = '';

      if (res.updatedUrl) {
        const siteId = getSiteId();
        locationValue = `/${siteId}${res.updatedUrl}`;
      } else if (isClient()) {
        locationValue = !location.search
          ? `${location.pathname}?`
          : `${location.pathname}?${location.search}`;
      }

      yield putResolve(setListingFirstProductsPage({ ...res, pageUrl: locationValue }));
      yield put(
        setSlpLoadingState({
          isLoadingMore: false,
          isScrollToTop: false,
          isSearchResultsAvailable: true,
          isDataLoading: false,
          shouldSlpScroll: getSlpScrollFlag(
            formDataPresent,
            isProcessedResponse,
            prefetchedResponse
          ),
        })
      );
      // eslint-disable-next-line sonarjs/no-duplicated-branches
    } else if (isOtherBrandExpABTestFlag && res?.isBopisFilterOn) {
      yield put(
        setSlpLoadingState({
          ...res,
          isLoadingMore: false,
          isScrollToTop: false,
          isDataLoading: false,
          isSearchResultsAvailable: true,
        })
      );
    } else if (isOtherBrandExpABTestFlag && !res?.redirect) {
      alternateBrandToSearch = getAlternateBrandToSearchFor(isSnjPjpBrandDisabled);
      alternateBrandWhereProductFound = alternateBrandToSearch?.[0];
      const brand = getBrand();
      const { brands, BRANDS_PJP_SNJ_DISABLED } = API_CONFIG;
      let otherBrands =
        brands &&
        brands.filter((brandName) => {
          return brandName !== brand;
        });

      if (isSnjPjpBrandDisabled) {
        otherBrands = BRANDS_PJP_SNJ_DISABLED?.filter((brandName) => brandName !== brand);
      }

      const reqObj = operatorInstance.getProductsListingFilters({
        state,
        formData,
        asPath,
        pageNumber: 1,
        location,
      });

      reqObj.navigation = navigation;
      reqObj.extraParams = {
        ...reqObj.extraParams,
        ...instanceProductListing.getExtraFilterParams(isFilterAbTestOn),
      };
      reqObj.brand = alternateBrandToSearch;
      const products = [];
      let length = 0;
      if (isCanada()) {
        alternateBrandToSearch = alternateBrandToSearch?.filter((excludeBrand) => {
          return excludeBrand !== 'pjp';
        });
      }
      const BrandConfig = getBrandConfig(state, brand);
      const currentBrand = BrandConfig?.[brand];
      const isRedirectFromNullSearch = true;

      while (length < otherBrands?.length) {
        if (alternateBrandToSearch[length]) {
          reqObj.brand = alternateBrandToSearch[length] || '';
          reqObj.acrossBrandApiCalled = true;
          const categoryFilter = Object.values(currentBrand[length])[0] || [];
          reqObj.departments = categoryFilter;
          if (isFromStoreModal) {
            reqObj.isFromStoreModal = true;
          }
          if (isCleanUrlForSizeEnabled) {
            reqObj.isCleanUrlForSizeEnabled = isCleanUrlForSizeEnabled;
          }
          if (isSLPNewTileImplementationEnabled) {
            reqObj.isSLPNewTileImplementationEnabled = isSLPNewTileImplementationEnabled;
          }
          res = yield call(
            instanceProductListing.getProducts,
            reqObj,
            state,
            prefetchedResponse,
            productsCount,
            xappURLConfig,
            isNonInvABTestEnabled,
            false,
            false,
            isRedirectFromNullSearch
          );

          products[length] = res?.loadedProductsPages[0];
          length += 1;
        } else {
          break;
        }
      }
      yield put(
        setAcrossBrandCallFlag({
          crossBrandProducts: products,
          acrossBrandApiCalled: true,
          alternateBrandsShown: alternateBrandToSearch,
        })
      );
      let productsArray = [];
      products?.forEach((productBlock) => {
        productsArray = productsArray?.concat(productBlock);
      });

      res.loadedProductsPages[0] = productsArray;
      res.totalProductsCount = productsArray?.length;
      if (!isDidYouMeanEnabled) {
        res.searchResultSuggestions = searchResultSuggestions;
      }

      clearOldSearchSuggestion(res, isDidYouMeanEnabled);
      const isTotalProductCountZero = res?.totalProductsCount === 0;
      const { layout, modules } = yield call(
        instanceProductListing.parsedModuleData,
        res.bannerInfo,
        getAPIConfig()
      );
      yield put(loadLayoutData(layout, 'searchListingPage'));
      yield put(loadModulesData(modules));

      let locationValue = '';

      if (res.updatedUrl) {
        const siteId = getSiteId();
        locationValue = `/${siteId}${res.updatedUrl}`;
      } else if (isClient()) {
        locationValue = getLocationValue(location);
      }
      yield putResolve(setListingFirstProductsPage({ ...res, pageUrl: locationValue }));
      yield put(
        setSlpLoadingState({
          isLoadingMore: false,
          isScrollToTop: false,
          isSearchResultsAvailable: true,
          isDataLoading: false,
          alternateBrandName: !isTotalProductCountZero ? alternateBrandWhereProductFound : '',
          shouldSlpScroll: getSlpScrollFlag(
            formDataPresent,
            isProcessedResponse,
            prefetchedResponse
          ),
        })
      );
    }
    if (!didYouMeanSuggestion) {
      let isSLPPersistEnabled = yield select(getIsSLPPersistEnabled);
      isSLPPersistEnabled = relevantSearchUndefinedABCheck(isSLPPersistEnabled);
      const slpPersistSearchText = getSearchTerm(url);
      if (isSLPPersistEnabled && searchReduxState !== searchQueryText) {
        payloadForSLP = payload;
        payloadForSLP.searchText = processSearchText(slpPersistSearchText);
        payloadForSLP.isSLPPersistEnabled = isSLPPersistEnabled;
        yield call(fetchSlpSearchResults, { payload: payloadForSLP });
      }
    }
  } catch (err) {
    logger.error(err);
    yield put(
      setSlpLoadingState({
        isLoadingMore: false,
        isScrollToTop: false,
        isSearchResultsAvailable: true,
        isDataLoading: false,
      })
    );
  }
}

export function* fetchMoreProducts({ payload = {} }) {
  try {
    const { url, isFilterAbTestOn } = payload;
    const state = yield select();
    const location = getUrl(url);
    const xappURLConfig = yield call(getUnbxdXappConfigs);
    yield put(setSlpLoadingState({ isLoadingMore: true }));
    const isCleanUrlForSizeEnabled = getIsCleanUrlForSizeEnabled(state);
    const isSLPNewTileImplementationEnabled = getIsSLPNewTileImplementationEnabled(state);
    const { appliedFiltersIds } = state[SLP_PAGE_REDUCER_KEY];
    const sort = (state[SLP_PAGE_REDUCER_KEY] && state[SLP_PAGE_REDUCER_KEY].appliedSortId) || '';
    const alternateBrandName =
      state[SLP_PAGE_REDUCER_KEY] && state[SLP_PAGE_REDUCER_KEY].alternateBrandName;
    const appliedFiltersAndSort = { ...appliedFiltersIds, sort };

    const lastLoadedPageNumber = getLastLoadedPageNumber(state);
    const reqObj = operatorInstance.getProductsListingInfo({
      state,
      filtersAndSort: appliedFiltersAndSort,
      pageNumber: lastLoadedPageNumber + 1,
      location,
      isLazyLoading: true,
    });
    reqObj.brand = alternateBrandName;
    reqObj.extraParams = {
      ...reqObj.extraParams,
      ...instanceProductListing.getExtraFilterParams(isFilterAbTestOn),
    };

    const isLowerEndDevice = isTier2Device() || isTier3Device();
    const productsCount = isLowerEndDevice
      ? PRODUCTS_PER_LOAD_LOWER_END_DEVICES
      : PRODUCTS_PER_LOAD;
    const isNonInvABTestEnabled = yield select(getIsNonInvSessionFlag);
    const isDidYouMeanAbEnabled = yield select(getIsDidYouMeanEnabled);
    const isDidYouMeanEnabled = isDidYouMeanAbEnabled === undefined || isDidYouMeanAbEnabled;
    if (didYouMeanSuggestion && isDidYouMeanEnabled) {
      reqObj.seoKeywordOrCategoryIdOrSearchTerm = didYouMeanSuggestion;
    }
    if (isCleanUrlForSizeEnabled) {
      reqObj.isCleanUrlForSizeEnabled = isCleanUrlForSizeEnabled;
    }
    if (isSLPNewTileImplementationEnabled) {
      reqObj.isSLPNewTileImplementationEnabled = isSLPNewTileImplementationEnabled;
    }
    const res = yield call(
      instanceProductListing.getProducts,
      reqObj,
      state,
      null,
      productsCount,
      xappURLConfig,
      isNonInvABTestEnabled,
      false
    );

    if (res) {
      yield put(setSlpProducts({ ...res }));
    }
    yield put(setSlpLoadingState({ isLoadingMore: false }));
  } catch (err) {
    logger.error(err);
    yield put(setSlpLoadingState({ isLoadingMore: false }));
  }
}

export function* fetchProductsOnPageChange({ payload = {} }) {
  try {
    const { url, selectedPage } = payload;
    const state = yield select();
    const isSLPNewTileImplementationEnabled = getIsSLPNewTileImplementationEnabled(state);
    const location = getUrl(url);
    const xappURLConfig = yield call(getUnbxdXappConfigs);
    yield put(setSlpLoadingState({ isLoadingMore: true }));

    const { appliedFiltersIds } = state[SLP_PAGE_REDUCER_KEY];
    const sort = (state[SLP_PAGE_REDUCER_KEY] && state[SLP_PAGE_REDUCER_KEY].appliedSortId) || '';
    const alternateBrandName =
      state[SLP_PAGE_REDUCER_KEY] && state[SLP_PAGE_REDUCER_KEY].alternateBrandName;
    const appliedFiltersAndSort = { ...appliedFiltersIds, sort, page: [selectedPage] };

    const reqObj = operatorInstance.getProductsListingInfo({
      state,
      filtersAndSort: appliedFiltersAndSort,
      pageNumber: selectedPage,
      location,
    });
    reqObj.brand = alternateBrandName;

    const productsCount = getProductsPerPageCount(state);
    const isNonInvABTestEnabled = yield select(getIsNonInvSessionFlag);
    const suggestionSearch = yield getDidYouMeanSuggestion();
    if (suggestionSearch) {
      reqObj.seoKeywordOrCategoryIdOrSearchTerm = suggestionSearch;
    }
    if (isSLPNewTileImplementationEnabled) {
      reqObj.isSLPNewTileImplementationEnabled = isSLPNewTileImplementationEnabled;
    }
    const res = yield call(
      instanceProductListing.getProducts,
      reqObj,
      state,
      null,
      productsCount,
      xappURLConfig,
      isNonInvABTestEnabled,
      false
    );

    let locationValue = '';
    if (res) {
      const siteId = getSiteId();
      locationValue = `/${siteId}${res.updatedUrl}`;
      yield put(setSlpProducts({ ...res, replace: true }));
    }
    yield delay(100);
    if (locationValue) {
      /* While doing pagination on slp, we need to update pageUrl as well. pageUrl is later used inside
      // Search Detail Container to compare with previous page url to fetch products first time when user lands on slp with a search query
      // Issue was on SLP, when user go to page2 the go to pdp, for first time doing a browser back
      // api call was firing, ideally it should never fire when you back from pdp, because products are already in redux
      // without this update api call was going again */
      yield put(setSlpLoadingState({ isLoadingMore: false, selectedPage, pageUrl: locationValue }));
    } else {
      yield put(setSlpLoadingState({ isLoadingMore: false, selectedPage }));
    }
  } catch (err) {
    logger.error(err);
    yield put(setSlpLoadingState({ isLoadingMore: false }));
  }
}

function* SearchPageSaga() {
  yield takeLatest(SLP_CONSTANTS.FETCH_SLP_PRODUCTS, fetchSlpProducts);
  yield takeLatest(SLP_CONSTANTS.GET_MORE_SLP_PRODUCTS, fetchMoreProducts);
  yield takeLatest(SLP_CONSTANTS.FETCH_PAGINATED_SLP_PRODUCTS, fetchProductsOnPageChange);
  yield takeLatest(SLP_CONSTANTS.GET_SLP_SEARCH_RESULTS, fetchSlpSearchResults);
}

export default SearchPageSaga;
